import { render, staticRenderFns } from "./GSelectedTemplateNotation.vue?vue&type=template&id=0d5ce98b&scoped=true&"
import script from "./GSelectedTemplateNotation.vue?vue&type=script&lang=ts&"
export * from "./GSelectedTemplateNotation.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectedTemplateNotation.vue?vue&type=style&index=0&id=0d5ce98b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ce98b",
  null
  
)

export default component.exports